import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=4e3ff4e8&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=ts"
export * from "./DeleteModal.vue?vue&type=script&lang=ts"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=4e3ff4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ff4e8",
  null
  
)

export default component.exports